import { createReducer, on } from '@ngrx/store';
import {
  tryAutoLogin,
  autoLoginSuccess,
  autoLoginFailure,
  login,
  loginSuccess,
  loginFailure,
  logout,
  logoutSuccess,
} from './auth.actions';

import { initialAuthState } from './auth.state';

export const authFeatureKey = 'auth'; // Clave para registrar este feature state

export const reducer = createReducer(
  initialAuthState,
  on(tryAutoLogin, (state) => ({
    ...state,
    initializing: true,
    loading: true, // Puede ser útil indicar carga también aquí
    error: null,
  })),
  on(autoLoginSuccess, (state, { user, token }) => ({
    ...state,
    isAuthenticated: true,
    user,
    token,
    loading: false,
    initializing: false,
    error: null,
  })),
  on(autoLoginFailure, (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    token: null,
    loading: false,
    initializing: false,
    error: null, // Opcional: podrías querer registrar un error específico de auto-login
  })),
  on(login, (state) => ({
    ...state,
    loading: true,
    error: null, // Limpiar errores anteriores al intentar un nuevo login
  })),
  on(loginSuccess, (state, { user, token }) => ({
    ...state,
    isAuthenticated: true,
    user,
    token,
    loading: false,
    error: null,
  })),
  on(loginFailure, (state, { error }) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    token: null,
    error,
    loading: false,
    initializing: false, // Ensure initialization is marked as complete on login failure
  })),
  on(logout, (state) => ({
    // Opcional: podrías poner loading a true si el logout implica alguna llamada asíncrona
    ...state,
    loading: true,
  })),
  on(logoutSuccess, (_state) => ({
    ...initialAuthState,
    isAuthenticated: false,
    user: null,
    token: null,
    loading: false,
    initializing: false, // Explicitly false, app has initialized
    error: null,
  }))
);
